export type AppErrorCode =
  | 'UNAUTHENTICATED'
  | 'SESSION_EXPIRED'
  | 'AUTH_FAILED'
  | 'FORBIDDEN'
  | 'SERVER_ERROR'
  | 'NETWORK_ERROR'
  | 'REQUEST_FAILED'

export class AppError extends Error {
  public readonly code: AppErrorCode
  public readonly status?: number
  public readonly redirectTo?: string
  public readonly isAppError = true
  /**
   * 后端 `detail` **原样**（T-084）。
   *
   * 本项目的错误契约是 `422/404/409 + detail = {code, reason, details[]}` ——
   * `details[]` 是**逐条拒绝理由**（运营/开发唯一能看懂"哪里写错"的地方）。
   * 若只把它压成 `message` 字符串，对象会变成 `[object Object]`、数组会变成逗号串，
   * 页面就拿不到逐条理由了。故这里**另外**挂一份原始 detail（不改变既有 `message` 语义 → 零回归）。
   */
  public readonly detail?: unknown

  constructor(code: AppErrorCode, message: string, status?: number, redirectTo?: string, detail?: unknown) {
    super(message)
    this.name = 'AppError'
    this.code = code
    this.status = status
    this.redirectTo = redirectTo
    this.detail = detail
  }
}

export function isAppError(error: unknown): error is AppError {
  return (
    error instanceof AppError ||
    (typeof error === 'object' && error !== null && (error as any).isAppError === true)
  )
}

export function toAppError(error: unknown, fallbackMessage = 'Request failed'): AppError {
  if (isAppError(error)) return error
  const message =
    typeof error === 'object' && error !== null && 'message' in error
      ? String((error as any).message || fallbackMessage)
      : fallbackMessage
  return new AppError('REQUEST_FAILED', message)
}
